export default __webpack_public_path__ + "static/resultamp-45f23a3fedc7050d91d0ad37ff24dccc.png";